export function parseUA() {
  const u = navigator.userAgent;
  const u2 = navigator.userAgent.toLowerCase();

  return {
    //移动终端浏览器版本信息
    trident: u.indexOf('Trident') > -1, //IE内核
    presto: u.indexOf('Presto') > -1, //opera内核
    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    macos:
      (u.indexOf('Macintosh') > -1 || u.indexOf('Mac OS X') > -1) &&
      u.indexOf('iPhone') === -1 &&
      u.indexOf('iPad') === -1, //macOS系统（排除iPhone和iPad）
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
    iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, //是否iPad
    webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
    iosv: u.substr(u.indexOf('iPhone OS') + 9, 3),
    weixin: u2.match(/MicroMessenger/i) == 'micromessenger',
    wxMiniprogram:
      (u.match(/MicroMessenger/i) && u.match(/miniprogram/i)) ||
      window.__wxjs_environment === 'miniprogram', //微信小程序环境
    ali: u.indexOf('AliApp') > -1,
    weibo: u2.match(/WeiBo/i) == 'weibo', //是否为微博客户端
    baidu: u.indexOf('Baidu') > -1 || u.indexOf('BIDUBrowser') > -1, //是否是百度浏览器
  };
}
